import { DefaultError } from '@tanstack/react-query';
import { Button } from 'components/atoms';
import { MagellanPopups } from 'components/molecules';
import { Form } from 'components/organisms';
import { sftpConnectionInitialValue } from 'components/organisms/forms/sftp-connection/SftpConnectionForm';
import { useCustomParamId } from 'hooks/useParamId';
import { useTranslation } from 'react-i18next';
import { PiCaretLeftBold, PiPencilSimpleLine } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { PopupActions } from 'reactjs-popup/dist/types';
import {
  useDeleteProviderSftpConnection,
  useGetProviderSftpConnection,
} from 'services/providers/sftp';
import { onErrorShowToast } from 'utils/service/errorHandler';

const SftpConnection = () => {
  const providerId = useCustomParamId('id', 'settings/provider');
  const salesChannelId = useCustomParamId(
    'salesChannelId',
    `settings/provider/${providerId}`
  );

  const navigate = useNavigate();
  const sftpConnection = useGetProviderSftpConnection(
    providerId,
    salesChannelId
  );
  const { t } = useTranslation();

  const removeSftpConnection = useDeleteProviderSftpConnection();

  const onRemove = async (actions: PopupActions) => {
    await removeSftpConnection.mutateAsync(
      { providerId, salesChannelId },
      {
        onError: (error: DefaultError) => {
          actions.close();
          onErrorShowToast(error);
        },
        onSuccess: () => navigate(`/settings/provider/${providerId}`),
      }
    );
  };

  return (
    <Form.SftpConnection
      i18nextPrefix=''
      initialValues={
        sftpConnection.data ? sftpConnection.data : sftpConnectionInitialValue
      }
      onSubmit={() => {}}
      status={{ displayMode: true, isLoading: sftpConnection.isLoading }}
      backPath={`/settings/provider/${providerId}`}
      customBackItem={
        <Button
          onlyIcon
          onClick={() => {
            navigate(`/settings/provider/${providerId}`);
          }}>
          <Button.Description description={t('button.back')} />

          <Button.Icon icon={<PiCaretLeftBold />} />
        </Button>
      }
      topbarContent={
        <div className='flex justify-end'>
          {!sftpConnection.data?.isPredefined && (
            <Button
              isClear
              onlyIcon
              onClick={() => {
                navigate(
                  `/settings/provider/${providerId}/sftp-connection/edit/${salesChannelId}/keys`,
                  {
                    replace: true,
                  }
                );
              }}>
              <Button.Description description={t('button.edit')} />

              <Button.Icon icon={<PiPencilSimpleLine />} />
            </Button>
          )}

          {!sftpConnection.data?.isPredefined && (
            <MagellanPopups.DeleteWarning onRemove={onRemove} />
          )}
        </div>
      }
    />
  );
};

export default SftpConnection;
